import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

import { register as registerColorCover } from "./color_cover.js"
import { register as registerMobileNav } from "./mobile_nav.js"

document.addEventListener("DOMContentLoaded", () => {
  registerColorCover();
  registerMobileNav();
})
